/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PromotionalBonusesExpireTypeApiModel } from './promotional-bonuses-expire-type';
import { RuleImplementationDataApiModel } from './rule-implementation-data';
import { BenefitsChargeTypeBaseApiModel } from './benefits-charge-type-base';
import { ThresholdsValueApiModel } from './thresholds-value';
import { LoyaltyRuleScopeApiModel } from './loyalty-rule-scope';
import { PromotionalBonusesStartingTypeApiModel } from './promotional-bonuses-starting-type';
import { LoyaltyRuleApplicableApiScopeApiModel } from './loyalty-rule-applicable-api-scope';
import { LoyaltyRuleDependsTypeApiModel } from './loyalty-rule-depends-type';
import { LoyaltyRuleApplicableForCustomerApiModel } from './loyalty-rule-applicable-for-customer';
import { LoyaltyRuleActionTypeApiModel } from './loyalty-rule-action-type';
import { LoyaltyRuleApplicableForSaleApiModel } from './loyalty-rule-applicable-for-sale';
import { PosEmbeddedApiModel } from './pos-embedded';
import { LoyaltyRuleDependsCalcPeriodApiModel } from './loyalty-rule-depends-calc-period';

export interface CheckImplementedRuleApiModel {
  action_type?: LoyaltyRuleActionTypeApiModel;
  /**
   * Rule is active
   */
  active?: number | null;
  applicable_api_scope?: LoyaltyRuleApplicableApiScopeApiModel;
  applicable_for_customer?: LoyaltyRuleApplicableForCustomerApiModel;
  applicable_for_sale?: LoyaltyRuleApplicableForSaleApiModel;
  /**
   * Apply rule when bonus points redeemed
   */
  apply_when_bonuses_redeemed?: number | null;
  /**
   * Apply rule when payments from customer accounts
   */
  apply_when_customers_account_payment?: number | null;
  /**
   * Rule applied type (0 - manual, 1 - automatic, 2 - coupon, 3 - display, 4 - corporate manual, 5 - corporate automatic)
   */
  automatic?: number | null;
  /**
   * Card category ID (optional, for rules with retail scope only)
   */
  card_category_id?: string | null;
  charge_type?: BenefitsChargeTypeBaseApiModel;
  /**
   * Combine with other rules flag
   */
  combine?: number | null;
  /**
   * Rule comment
   */
  comment?: string | null;
  /**
   * Corporate customers category ID (optional, for rules with corporate scope only)
   */
  corporate_customer_category_id?: string | null;
  /**
   * Consider redeemed bonuses when calculating the rule value (null if used loyalty settings)
   */
  count_bonuses_redeemed_amount?: number | null;
  /**
   * Batch code of emitted coupons (optional)
   */
  coupon_batch_code?: string | null;
  /**
   * Do not add emitted coupons to the customer\'s wallet (optional)
   */
  coupon_do_not_add_to_wallet?: number;
  depends_calc_period?: LoyaltyRuleDependsCalcPeriodApiModel;
  /**
   * Dependencies period limited by current category period
   */
  depends_calc_period_related_to_current_category?: number;
  depends_excluded_item_categories?: Array<string>;
  depends_excluded_items?: Array<string>;
  depends_included_item_categories?: Array<string>;
  depends_included_items?: Array<string>;
  depends_type?: LoyaltyRuleDependsTypeApiModel;
  excluded_item_categories?: Array<string>;
  excluded_items?: Array<string>;
  /**
   * Rule ID
   */
  id?: string | null;
  implementation_data?: RuleImplementationDataApiModel;
  included_item_categories?: Array<string>;
  included_items?: Array<string>;
  /**
   * Interpret zero quantity of an item as one (for item action types only)
   */
  item_zero_quantity_as_one_quantity?: number;
  /**
   * maximum limit items in check (0 - no limits)
   */
  items_limit_max?: number | null;
  /**
   * minimum limit items in check (0 - no limits)
   */
  items_limit_min?: number | null;
  /**
   * Loyalty ID
   */
  loyalty_id?: string | null;
  /**
   * Apply rule only once per check (for coupon automatic only)
   */
  only_once_per_check?: number;
  /**
   * List of related POS
   */
  pos?: Array<PosEmbeddedApiModel> | null;
  /**
   * Rule priority(0 - the greatest one)
   */
  priority?: number | null;
  /**
   * Value of promotional bonuses expire date
   */
  promotional_bonuses_expire_date?: string | null;
  promotional_bonuses_expire_type?: PromotionalBonusesExpireTypeApiModel;
  /**
   * Value of promotional bonuses expire
   */
  promotional_bonuses_expire_value?: number | null;
  /**
   * Value of promotional bonuses start date
   */
  promotional_bonuses_starting_date?: string | null;
  promotional_bonuses_starting_type?: PromotionalBonusesStartingTypeApiModel;
  /**
   * Value of promotional bonuses start
   */
  promotional_bonuses_starting_value?: number | null;
  /**
   * Rule is scheduled
   */
  scheduled?: number | null;
  scope?: LoyaltyRuleScopeApiModel;
  /**
   * Special account ID
   */
  special_account_id?: string | null;
  /**
   * Rule valid from time (used if rule is scheduled, in RFC3339)
   */
  time_from?: string | null;
  /**
   * Rule valid to time (used if rule is scheduled, in RFC3339)
   */
  time_to?: string | null;
  /**
   * Rule title
   */
  title?: string | null;
  /**
   * Alternative calc by items dependencies usage
   */
  use_alternative_dependencies_by_items?: number;
  /**
   * Rule valid from date (used if rule is scheduled, in RFC3339)
   */
  valid_after?: string | null;
  /**
   * Rule valid to date (used if rule is scheduled, in RFC3339)
   */
  valid_before?: string | null;
  /**
   * Values set based on thresholds
   */
  value?: Array<ThresholdsValueApiModel>;
  week_days?: Array<CheckImplementedRuleApiModelWeekDaysEnum>;
}
export enum CheckImplementedRuleApiModelWeekDaysEnum {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday'
}
